export default __webpack_public_path__ + "static/media/adetola.fc3b576a.webp";